const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Vantage Bloomdale",

  webfeedDebuggerWebsiteUrl:
    "https://vantagebloomdale.avid.com.au/now-selling/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
